var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.hasAnyImage
        ? _c(
            "b-form-group",
            [
              _c(
                "b-button",
                {
                  staticClass: "w-100 mt-2",
                  on: { click: _vm.translateImage },
                },
                [_vm._v("\n      Translate Image\n    ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }